export default __webpack_public_path__ + "static/media/Dashboard.6f26c36e.png";